// 項目庫 (報價/訂單新項目自動存儲)
import React, { useEffect, useState } from 'react';
import { api, money, CATEGORIES } from '../api.js';
import { Modal, Field, Loading, Empty, PageHead, useToast, useConfirm, CategoryTag } from '../ui.jsx';

const CATS = ['INSTALLATION', 'MAINTENANCE', 'ECALL', 'PROCUREMENT'];

function ItemEditor({ initial, onSaved, onClose, defaultCat }) {
  const { toast } = useToast();
  const isNew = !initial?.id;
  const [f, setF] = useState({ code: initial?.code || '', description: initial?.description || '', category: initial?.category || defaultCat || 'INSTALLATION', unit: initial?.unit || '項', unit_price: initial?.unit_price ?? 0 });
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const save = async () => {
    if (!f.description.trim()) return toast('請填寫項目描述', 'err');
    try {
      if (isNew) await api.post('/items', f); else await api.put(`/items/${initial.id}`, f);
      toast('已儲存'); onSaved();
    } catch (e) { toast(e.message, 'err'); }
  };
  return (
    <Modal onClose={onClose} icon="🧰" title={isNew ? '➕ 新增項目' : '✏️ 編輯項目'}
      footer={<><button className="btn" onClick={onClose}>取消</button><button className="btn primary" onClick={save}>💾 儲存</button></>}>
      <div className="form-grid">
        <Field label="類別" required>
          <select className="select" value={f.category} onChange={e => set('category', e.target.value)}>
            {CATS.map(c => <option key={c} value={c}>{CATEGORIES[c].label}</option>)}
          </select>
        </Field>
        <Field label="項目編號"><input className="input" value={f.code} onChange={e => set('code', e.target.value)} /></Field>
        <Field label="描述" required span2><input className="input" value={f.description} onChange={e => set('description', e.target.value)} /></Field>
        <Field label="單位"><input className="input" value={f.unit} onChange={e => set('unit', e.target.value)} /></Field>
        <Field label="預設單價"><input className="input num-input" type="number" step="0.01" value={f.unit_price} onChange={e => set('unit_price', e.target.value)} /></Field>
      </div>
      <p className="muted mt">💡 喺報價單/訂單入面新輸入嘅項目會自動存入項目庫，下次可以直接揀。</p>
    </Modal>
  );
}

export default function Items() {
  const { toast } = useToast();
  const [confirm, confirmNode] = useConfirm();
  const [rows, setRows] = useState(null);
  const [cat, setCat] = useState('INSTALLATION');
  const [editor, setEditor] = useState(null);
  const [q, setQ] = useState('');
  const refresh = () => api.get(`/items?category=${cat}`).then(setRows);
  useEffect(() => { refresh(); }, [cat]);
  const del = (it) => confirm(`刪除項目「${it.description}」？`, async () => {
    try { await api.del(`/items/${it.id}`); toast('已刪除'); refresh(); } catch (e) { toast(e.message, 'err'); }
  }, { danger: true, okLabel: '刪除' });
  const filtered = (rows || []).filter(x => !q || x.description.includes(q) || (x.code || '').toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHead icon="🧰" title="項目庫" desc="常用工程/服務項目 — 開單時快速選擇，新項目自動入庫"
        actions={<>
          <div className="search-box"><input className="input" placeholder="搜尋項目…" value={q} onChange={e => setQ(e.target.value)} /></div>
          <button className="btn primary" onClick={() => setEditor({})}>➕ 新增項目</button>
        </>} />
      <div className="tabs">
        {CATS.map(c => <button key={c} className={`tab ${cat === c ? 'active' : ''}`} onClick={() => setCat(c)}>{CATEGORIES[c].icon} {CATEGORIES[c].label}</button>)}
      </div>
      <div className="card">
        {rows === null ? <Loading /> : filtered.length === 0 ? <Empty icon="🧰" text="此類別未有項目" /> : (
          <div className="tbl-wrap">
            <table className="tbl">
              <thead><tr><th>編號</th><th>描述</th><th>單位</th><th className="num">預設單價</th><th className="num">使用次數</th><th></th></tr></thead>
              <tbody>
                {filtered.map(it => (
                  <tr key={it.id}>
                    <td className="strong">{it.code || '—'}</td>
                    <td>{it.description}</td>
                    <td>{it.unit}</td>
                    <td className="num strong">{money(it.unit_price)}</td>
                    <td className="num"><span className="st st-gray">{it.usage_count} 次</span></td>
                    <td>
                      <div className="row" style={{ flexWrap: 'nowrap' }}>
                        <button className="btn sm" onClick={() => setEditor({ ...it })}>✏️</button>
                        <button className="btn sm coral" onClick={() => del(it)}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {editor && <ItemEditor initial={editor.id ? editor : {}} defaultCat={cat} onClose={() => setEditor(null)} onSaved={() => { setEditor(null); refresh(); }} />}
      {confirmNode}
    </div>
  );
}
